var map = {
	"./2FA-icon.png": 12631,
	"./2FA-not-working.png": 68193,
	"./account-recovery.png": 85170,
	"./corporate.png": 85493,
	"./document-text.png": 73904,
	"./email-icon.png": 75584,
	"./email_activation.png": 93169,
	"./error.png": 37330,
	"./eye-slash.svg": 90561,
	"./eye.svg": 42575,
	"./global_coin.png": 87025,
	"./global_coin_in.png": 38647,
	"./google.svg": 13995,
	"./individual.png": 25221,
	"./lock-icon.png": 40840,
	"./malaysia_coin.png": 61037,
	"./malaysia_coin_in.png": 62721,
	"./message.png": 42504,
	"./no-update.png": 85336,
	"./passkeys.png": 20770,
	"./password-icon.png": 39609,
	"./phone-icon.png": 60386
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32167;